/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.9
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Client } from '../model';
// @ts-ignore
import { HTTPValidationError } from '../model';
// @ts-ignore
import { UpdateClientProductTypesWriteRequest } from '../model';
// @ts-ignore
import { UpdateClientVendorWriteRequest } from '../model';
/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Update Product Types
         * @param {string} clientId 
         * @param {UpdateClientProductTypesWriteRequest} updateClientProductTypesWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductTypesDockschedulingClientsClientIdProductTypesPut: async (clientId: string, updateClientProductTypesWriteRequest: UpdateClientProductTypesWriteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateProductTypesDockschedulingClientsClientIdProductTypesPut', 'clientId', clientId)
            // verify required parameter 'updateClientProductTypesWriteRequest' is not null or undefined
            assertParamExists('updateProductTypesDockschedulingClientsClientIdProductTypesPut', 'updateClientProductTypesWriteRequest', updateClientProductTypesWriteRequest)
            const localVarPath = `/dockscheduling/clients/{client_id}/product-types`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientProductTypesWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Vendor
         * @param {string} clientId 
         * @param {UpdateClientVendorWriteRequest} updateClientVendorWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorDockschedulingClientsClientIdVendorPut: async (clientId: string, updateClientVendorWriteRequest: UpdateClientVendorWriteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('updateVendorDockschedulingClientsClientIdVendorPut', 'clientId', clientId)
            // verify required parameter 'updateClientVendorWriteRequest' is not null or undefined
            assertParamExists('updateVendorDockschedulingClientsClientIdVendorPut', 'updateClientVendorWriteRequest', updateClientVendorWriteRequest)
            const localVarPath = `/dockscheduling/clients/{client_id}/vendor`
                .replace(`{${"client_id"}}`, encodeURIComponent(String(clientId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientVendorWriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Update Product Types
         * @param {string} clientId 
         * @param {UpdateClientProductTypesWriteRequest} updateClientProductTypesWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId: string, updateClientProductTypesWriteRequest: UpdateClientProductTypesWriteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId, updateClientProductTypesWriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Vendor
         * @param {string} clientId 
         * @param {UpdateClientVendorWriteRequest} updateClientVendorWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVendorDockschedulingClientsClientIdVendorPut(clientId: string, updateClientVendorWriteRequest: UpdateClientVendorWriteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVendorDockschedulingClientsClientIdVendorPut(clientId, updateClientVendorWriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Update Product Types
         * @param {string} clientId 
         * @param {UpdateClientProductTypesWriteRequest} updateClientProductTypesWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId: string, updateClientProductTypesWriteRequest: UpdateClientProductTypesWriteRequest, options?: any): AxiosPromise<Client> {
            return localVarFp.updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId, updateClientProductTypesWriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Vendor
         * @param {string} clientId 
         * @param {UpdateClientVendorWriteRequest} updateClientVendorWriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVendorDockschedulingClientsClientIdVendorPut(clientId: string, updateClientVendorWriteRequest: UpdateClientVendorWriteRequest, options?: any): AxiosPromise<Client> {
            return localVarFp.updateVendorDockschedulingClientsClientIdVendorPut(clientId, updateClientVendorWriteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @summary Update Product Types
     * @param {string} clientId 
     * @param {UpdateClientProductTypesWriteRequest} updateClientProductTypesWriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId: string, updateClientProductTypesWriteRequest: UpdateClientProductTypesWriteRequest, options?: any) {
        return ClientApiFp(this.configuration).updateProductTypesDockschedulingClientsClientIdProductTypesPut(clientId, updateClientProductTypesWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Vendor
     * @param {string} clientId 
     * @param {UpdateClientVendorWriteRequest} updateClientVendorWriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateVendorDockschedulingClientsClientIdVendorPut(clientId: string, updateClientVendorWriteRequest: UpdateClientVendorWriteRequest, options?: any) {
        return ClientApiFp(this.configuration).updateVendorDockschedulingClientsClientIdVendorPut(clientId, updateClientVendorWriteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
